import React, { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  updateUser,
  addUser,
  clearUser,
  loadClientsList,
} from '../../../actions/adminAction';
import { setAlert } from '../../../actions/alertAction';
import Alert from '../../../layouts/Alert';

/**
 * SuperAdmin: All settings, Virbrix Lite, 3D Fusion, Analytics Assistant, API Integration, Portfolio
 * Demo: Global User can see only Contoso Data
 * Admin: See 4 Main Modules for your company
 * End User: Mix (Virbrix Lite + salvation army) / Virbrix 4 Main module 
 * 3D Fusion (Operator): Only see 3D Fusion module
*/



const UserForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const authUser = useSelector((state) => state.auth.user);
  const user = useSelector((state) => state.admin.user);
  const userLoading = useSelector((state) => state.admin.userLoading);
  const clientsList = useSelector((state) => state.admin.clientsList);
  const clientListLoading = useSelector(
    (state) => state.admin.clientListLoading,
  );
    const dark = useSelector((state) => state.dark.data);

  const [formData, setFormData] = useState({
    id: user === null ? '' : user.id !== undefined ? user.id : '',
    email: user === null ? '' : user.email !== undefined ? user.email : '',
    role_id: user === null ? '' : user.email !== undefined ? user.role_id : '',
    client_id:
      user === null ? '' : user.email !== undefined ? user.client_id : '',
  });

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const { email, id, role_id, client_id } = formData;

  const onSubmit = (e) => {
    e.preventDefault();
    window.scrollTo(0, 0);
    if (location.pathname.includes('add')) {
      console.log('add');
      if (role_id !== '') {
        dispatch(addUser(formData));
        navigate('/admin/users');
      }
    } else if (location.pathname.includes('edit')) {
      console.log('edit');
      dispatch(updateUser(id, formData));
      navigate('/admin/users');
      dispatch(clearUser());
    }
  };

  useEffect(() => {
    if (clientsList.length === 0 && clientListLoading) {
      dispatch(loadClientsList());
    }
  }, [clientsList, clientListLoading]);

  useEffect(() => {
    if (user == null && location.pathname.includes('edit')) {
      navigate('/admin/users');
    }
  }, [user]);

  return (
    <div className='admin-card px-sm-5 py-sm-4 p-2 me-0 mt-0 mb-0 text-main'>
      <div className='mb-2 '>
        <h6 className='text-main my-3'>Admin / Users / User</h6>
        <div className='d-sm-flex  w-100 align-items-center justify-content-between'>
          <div className='d-flex mb-2 mb-sm-0 align-items-center'>
            <div
              className='admin-back mx-2  rounded-circle border border-2 d-flex align-items-center justify-content-center'
              onClick={() => {
                navigate(-1);
              }}
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='18'
                height='18'
                fill='currentColor'
                className='bi bi-arrow-left-short'
                viewBox='0 0 16 16'
              >
                <path
                  fillRule='evenodd'
                  d='M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z'
                />
              </svg>
            </div>
            <h4 className='m-0'>
              {location.pathname.includes('add') ? 'Add User' : 'Edit'}
            </h4>
          </div>
        </div>
      </div>
      <form
        className='card w-100 p-2 p-sm-3 p-lg-4 shadow-lg border-0 admin-list mb-2 h-max-content'
        onSubmit={(e) => onSubmit(e)}
      >
        <Alert />
        <div className='row'>
          <div className='col-lg-4 col'>
            <div className='mb-3'>
              <h5 className='text-main fw-bold'>Email</h5>
              <input
                type='email'
                className='form-control rounded admin-list text-main'
                id='email'
                placeholder='Enter email...'
                required
                value={email}
                onChange={(e) => onChange(e)}
              />
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-lg-4 col'>
            <div className='mb-3'>
              <h5 className='text-main fw-bold'>Role</h5>
              <select
                 className="form-select admin-list"
                 style={{
                   background: `#272a3d url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='${
                     dark ? 'white' : ''
                   }' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right .75rem center/8px 10px`,
                 }}
                aria-label='Default select example'
                id='role_id'
                value={role_id}
                onChange={(e) => onChange(e)}
                required
              >
                <option value={''}>------------------</option>
                {authUser.role_id === 1 && (
                  <option value={1}>{'Super Admin'}</option>
                )}
                <option value={2}>{'Admin'}</option>
                <option value={3}>{'Demo'}</option> 
                <option value={4}>{'End User'}</option> 
                <span>Virbrix Lite</span>
                <option value={5}>{'3D Fusion'}</option>
              </select>
            </div>
          </div>
        </div>
        {clientsList.length > 0 &&
          role_id != 1 && (
            <div className='row'>
              <div className='col-lg-4 col'>
                <div className='mb-3'>
                  <h5 className='text-main fw-bold'>Company</h5>
                  <select
                    name='client_id'
                    id='client_id'
                    className='form-select admin-list'
                    onChange={(e) => onChange(e)}
                    value={client_id}
                  >
                    <option value={null}>------------------</option>
                    {clientsList.map((client) => (
                      <option value={client.id}>{client.title}</option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          )}

        <div className='d-flex align-items-center justify-content-center'>
          <button
            type='submit'
            className='admin-list-btn-secondary text-main btn-block btn px-5'
          >
            Save
          </button>
        </div>
      </form>
    </div>
  );
};

export default UserForm;
